module.exports = __webpack_public_path__ + "img/fire.1e4b28f9.svg";